
    export function getDeviceType() {
        const size = window.innerWidth;
        const ua = navigator.userAgent;
        if (/(tablet|iPad|playbook|silk)|(android(?!.*mobi))/i.test(ua) || (size <= 1200 && size > 768)) {
            return "tablet";
        } else if (['iPad Simulator','iPhone Simulator','iPod Simulator','iPad','iPhone','iPod',].includes(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document && navigator.maxTouchPoints > 1) || (size <= 1200 && size > 768) ) {
            return "tablet";
        }
        else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua) || (size <= 768) ) {
            return "mobile";
        }
        return "desktop";
    };


  